<template>
  <div>
    <a-card>
      <div slot="title">
        {{ this.id ? 'Edit' : 'Create' }} Rencana Belanja
      </div>
      <a-form-model ref="ruleForm" :model="form.model" :rules="form.rules">
        <a-row :gutter="8" type="flex" align="bottom">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Budget Type" prop="budget_type">
              <a-select showSearch v-model="form.model.budget_type" :disabled="loading.table.left || dtlNotNull"
                @change="(e) => { handleJenisAnggaran(e); onchangedHeader('budget_type'); }">
                <a-select-option v-for="item in getJenisAnggaran" :key="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Cost Center" prop="cost_center">
              <a-select showSearch v-model="form.model.cost_center" :disabled="loading.table.left || dtlNotNull"
                @change="(e) => { handle_Cost(e); onchangedHeader('cost_center'); }">
                <a-select-option v-for="item in costCenter" :key="item.value">
                  {{ item.text }} ({{
                    item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                  }})
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 15 }" :lg="{ span: 6 }">
            <a-form-model-item label="Plafon Period" prop="period">
              <a-select showSearch v-model="form.model.period" :disabled="disabled.header || dtlNotNull">
                <a-select-option v-for="item in list_periode" :key="item.key" @change="onchangedHeader('period')">{{
                  item.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 9 }" :lg="{ span: 2 }" class="view-col">
            <a-form-model-item prop="view">
              <a-button :disabled="!form.model.cost_center" :loading="loading.view" block icon="search" type="primary" @click="getPreviousBudget()">View</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-slider v-if="!getScreen" id="positionCol" class="slider-cep" v-model="positionCol" :tooltipVisible="false"
          :min="0" :max="24" />
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: positionCol }">
            <a-table :columns="columns.left" :dataSource="datasource.left" id="id_table_left" size="small"
              :rowKey="(record) => { return record.key; }" :pagination="false" :loading="loading.table.left"
              :scroll="{ x: 800, y: '100vh' }" :expanded-row-keys.sync="expandedKeys" :rowClassName="getRowClassName"
              bordered>
              <template slot="aksi" slot-scope="item">
                <a-button v-if="!item.children && item.saldo > 0" size="small" icon="plus" type="primary"
                  @click="handleAdd(item)"></a-button>
              </template>
              <template slot="budget" slot-scope="item">
                {{ item.item }}
              </template>
              <template slot="budget_code" slot-scope="item">
                {{ item.kode_anggaran }}
              </template>
              <template slot="balance" slot-scope="item">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="item.saldo ? item.saldo : 0" />
              </template>
            </a-table>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 - positionCol }">
            <a-table :columns="columns.right" :dataSource="datasource.right"
              :rowKey="(record, index) => { return index; }" id="id_table_right" size="small" :pagination="false"
              :loading="loading.table.right" :scroll="{ x: 1000, y: '100vh' }" bordered>
              <template slot="no" slot-scope="text,item,index">
                {{ index + 1 }}
              </template>
              <template slot="sts" slot-scope="item">
                <div class="slot_sts">
                  <a-tag
                    :color="item.status == 'High' ? 'red' : (item.status == 'Normal' ? 'green' : (item.status == 'Direct' ? 'purple' : 'default'))"
                    :class="item.status == 'Low' ? 'width-full tag-defaults' : 'width-full'">{{ item.status ?
                      (item.status == 'Direct' ? 'Direct Allocated' : item.status) : '' }}</a-tag>
                </div>
              </template>
              <template slot="cost_center" slot-scope="item">
                {{ item.cost_center_kode }}
              </template>
              <template slot="code_budget" slot-scope="item">
                <div>{{ item.kode_anggaran }}</div>
                <div>{{ item.item_anggaran }}</div>
              </template>
              <template slot="description" slot-scope="item">
                {{ item.deskripsi }}
              </template>
              <template slot="nilai" slot-scope="item">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="item.nilai_rencana" />
              </template>
              <template slot="aksi" slot-scope="item">
                <a-button size="small" icon="close" type="danger"
                  :loading="loading.table.key_right == item.rencana_belanja_dtl_id" @click="handleDelete(item)">
                </a-button>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-form-model>
      <div slot="actions" class="m-display-flex space-between">
        <div></div>
        <div>
          <a-button-group>
            <a-button v-if="!isrevise"
              :disabled="loading.submit || loading.table.left || loading.table.right" @click="saveTrans('draft')">
              <span>Save Draft</span>
            </a-button>
            <a-button type="primary" :loading="loading.submit" :disabled="loading.table.left || loading.table.right"
              @click="saveTrans('submit')">
              <span>Submit</span>
            </a-button>
          </a-button-group>
        </div>
      </div>

      <!-- modal -->
      <a-modal v-model:visible="show_modal_view" :title="'List Budget : '+modal_title" width="70%">
        <a-table 
        :columns="columns_modal" 
        :dataSource="list_previous_budget" 
        id="rencana_belanja_dtl_id" 
        size="small"
        :rowKey="(record) => { return record.key; }" :pagination="false" 
        :loading="loading.table.left"
        :expanded-row-keys.sync="expandedKeys" 
        :rowClassName="getRowClassName"
        bordered>
          <template slot="no" slot-scope="text,item,index">
            {{ index + 1 }}
          </template>
          <template slot="sts" slot-scope="item">
            <div class="slot_sts">
              <a-tag
                :color="item.status == 'High' ? 'red' : (item.status == 'Normal' ? 'green' : (item.status == 'Direct' ? 'purple' : 'default'))"
                :class="item.status == 'Low' ? 'width-full tag-defaults' : 'width-full'">{{ item.status ?
                (item.status == 'Direct' ? 'Direct Allocated' : item.status) : '' }}
              </a-tag>
            </div>
          </template>
          <template slot="cost_center" slot-scope="item">
            {{ item.cost_center_kode }}
          </template>
          <template slot="code_budget" slot-scope="item">
            <div>{{ item.kode_anggaran }}</div>
            <div>{{ item.item_anggaran }}</div>
          </template>
          <template slot="description" slot-scope="item">
            {{ item.deskripsi }}
          </template>
          <template slot="nilai" slot-scope="item">
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="item.nilai_rencana" />
          </template>
          <template slot="aksi" slot-scope="item">
            <a-button 
              size="small" 
              icon="plus" 
              type="primary"
              :loading="temp_id == item.rencana_belanja_dtl_id && loading.add" 
              @click="addPreviousBudget(item)"
            >
            </a-button>
          </template>
        </a-table>

        <template #footer>
          <a-button @click="show_modal_view = false">
            Close
          </a-button>
        </template>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import lodash, { method } from 'lodash';
import deepdash from 'deepdash';
const _ = deepdash(lodash);
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "expenditurePlanCreate",
  mixins: [GlobalMethod, CurrencyFormat],
  components: {},
  props: ["id"],
  data() {
    return {
      form: {
        model: {
          period: null,
          budget_type: null,
          cost_center: null
        },
        rules: {
          period: {
            required: true,
            message: "Plafon Periode is required!",
            trigger: "change",
          },
          budget_type: {
            required: true,
            message: "Budget Type is required!",
            trigger: "change",
          },
          cost_center: {
            required: true,
            message: "Cost Center is required!",
            trigger: "change",
          },
        }
      },
      costCenter: [],
      datasource: {
        left: [],
        right: []
      },
      pagination: {
        right: {
          page: 1,
          onChange: (page) => {
            this.pagination.right.page = page;
          },
          pageSize: 10,
          size: "small",
        }
      },
      loading: {
        table: {
          left: false,
          right: false,
          key_right: ''
        },
        submit: false,
        view: false,
        add: false
      },
      disabled: {
        header: false
      },
      expandedKeys: [],
      positionCol: 12,
      addModal: {
        desc: null,
        nilai: null,
        max_nilai: null,
        choosing_sts: null
      },
      id_newtrans: null,
      base_data_periode: [],
      show_modal_view: false,
      modal_title: "",
      list_previous_budget: [],
      temp_id: ''
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeStandartFormat",
      "getJenisAnggaran",
      "getCostCenter",
    ]),
    list_periode() {
      return this.id && this.form.model.period ?
        [
          {
            key: moment(this.form.model.period).format("YYYY-MM"),
            label: moment(this.form.model.period).locale("id").format('MMMM-YYYY')
          },
        ]
        : this.getPeriodeList()
    },
    columns() {
      return {
        left: [
          {
            title: "Budgeting",
            scopedSlots: { customRender: "budget" },
          },
          {
            title: "Period",
            scopedSlots: { customRender: "period" },
            children: [
              {
                title: "Code Budget",
                width: '200px',
                scopedSlots: { customRender: "budget_code" },
              },
              {
                title: "Balance",
                width: '150px',
                scopedSlots: { customRender: "balance" },
              },
            ]
          },
          {
            title: "#",
            width: '50px',
            align: "center",
            fixed: "right",
            scopedSlots: { customRender: "aksi" },
          },
        ],
        right: [
          {
            title: "#",
            width: '50px',
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Status",
            width: '150px',
            scopedSlots: { customRender: "sts" },
          },
          {
            title: "Cost Center",
            width: '150px',
            scopedSlots: { customRender: "cost_center" },
          },
          {
            title: "Code | Item Budget",
            width: '250px',
            scopedSlots: { customRender: "code_budget" },
          },
          {
            title: "Description",
            scopedSlots: { customRender: "description" },
          },
          {
            title: "Value",
            width: '150px',
            scopedSlots: { customRender: "nilai" },
          },
          {
            title: "#",
            width: '50px',
            fixed: "right",
            scopedSlots: { customRender: "aksi" },
          },
        ]
      }
    },

    columns_modal(){
      return [
        {
          title: "#",
          width: '50px',
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Status",
          width: '150px',
          scopedSlots: { customRender: "sts" },
        },
        {
          title: "Cost Center",
          width: '150px',
          scopedSlots: { customRender: "cost_center" },
        },
        {
          title: "Code | Item Budget",
          scopedSlots: { customRender: "code_budget" },
        },
        {
          title: "Description",
          scopedSlots: { customRender: "description" },
        },
        {
          title: "Value",
          scopedSlots: { customRender: "nilai" },
        },
        {
          title: "Aksi",
          scopedSlots: { customRender: "aksi" },
        },
      ]
    },

    dtlNotNull() {
      return this.datasource.right.length > 0
    },
    isrevise(){
      return this.$route.name.includes('expenditurePlanRevise')
    }
  },
  mounted() {
    this.$store.dispatch("FETCH_COST_CENTER");
    if (this.id) {
      this.id_newtrans = this.id
      this.disabled.header = true

      this.loading.table.left = true
      this.loading.table.right = true
      this.asyncAxiosGet(this.$route.name.includes('expenditurePlanRevise') ? "Rencana_belanja/revisi" : "Rencana_belanja/draft",
        this.getAuth,
        {
          rencana_belanja_id: this.id_newtrans,
        }
      ).then(async (response) => {
        this.form.model.period = this.$route.name.includes('expenditurePlanRevise') ? moment(response.hdr[0].periode_plafon).format("YYYY-MM") :
          moment(response.periode).format("YYYY-MM")

        this.form.model.budget_type = response.dtl[0].jns_anggaran_id
        this.handleJenisAnggaran(this.form.model.budget_type)

        this.form.model.cost_center = response.dtl[0].anggaran_id
        this.handle_Cost(this.form.model.cost_center)

        this.datasource.right = response.dtl
      }).catch((err) => {
        this.loading.table.left = false
        this.loading.table.right = false

        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error-other", responses.message);

        setTimeout(
          function () {
            this.$router.push({
              name: "expenditurePlan"
            });
          }.bind(this),
          3000
        );
      });
    } else {
      this.getAvailabelPeriode();
    }
  },
  methods: {
    moment,
    onchangedHeader(type) {
      this.datasource.left = []
      if (this.id_newtrans == null) {
        this.disabled.header = false
      }

      if (type == 'period') {
        this.form.model.budget_type = null,
          this.form.model.cost_center = null
      } else if (type == "budget_type") {
        this.form.model.cost_center = null
      }
    },
    handleJenisAnggaran(e) {
      this.form.model.cost_center = null;
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.costCenter = filter;
    },
    async handle_Cost(e) {
      this.loading.table.left = true
      this.loading.table.right = true
      this.disabled.header = true
      await this.asyncAxiosGet("Rencana_belanja/budget",
        this.getAuth,
        {
          anggaran_id: e,
          rencana_belanja_id: this.id_newtrans
        }
      ).then((res) => {
        this.datasource.left = [{ ...res.budget }];
        this.expandAll()

        this.loading.table.left = false
        this.loading.table.right = false

        if (this.datasource.right.length == 0) {
          this.disabled.header = false
        }
      }).catch(() => {
        this.loading.table.left = false
        this.loading.table.right = false
      });
    },
    getAllKeys(data) {
      let keys = [];
      data.forEach(item => {
        keys.push(item.key);
        if (item.children && item.children.length > 0) {
          keys = keys.concat(this.getAllKeys(item.children));
        }
      });
      return keys;
    },
    expandAll() {
      this.expandedKeys = this.getAllKeys(this.datasource.left);
    },
    validateMaxValue(e, maxValue) {
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
      if (allowedKeys.includes(e.key)) return;

      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
        return;
      }

      const currentRawValue = e.target.value.replace(/,/g, '');
      const predictedValue = Number(currentRawValue + e.key);

      if (predictedValue > maxValue) {
        e.preventDefault();
      }
    },
    handleAdd(item) {
      if (!this.form.model.period) {
        this.displayMessageValue("error-other", 'Plafon Period is Required!');
        return;
      }
      const that = this;
      that.addModal.desc = ''
      that.addModal.nilai = item.saldo
      that.addModal.max_nilai = item.saldo
      that.addModal.choosing_sts = 'Normal'

      this.$confirm({
        title: false,
        content: (h) => {
          return h('div', { style: {} }, [
            h('div', { style: {} }, [
              h('label', { style: { fontWeight: 'bold' } }, 'Kode Budget : ' + item.kode_anggaran),
            ]),
            h('div', { style: { marginTop: '10px' } }, [
              h('label', { style: { fontWeight: 'bold' } }, 'Item Name   : ' + item.item),
            ]),
            h('div', { style: { marginTop: '10px' } }, [
              h('label', { style: {} }, 'Keterangan Rencana Belanja'),
              h('a-textarea', {
                props: {
                  autoFocus: true,
                  required: true,
                  value: that.addModal.desc
                },
                attrs: {
                  maxLength: 255,
                  placeholder: 'Type here...'
                },
                on: {
                  blur: (val) => {
                    that.addModal.desc = val.target.value;
                  },
                }
              })
            ]),

            h('div', { class: 'margin-top' }, [
              h('label', 'With Status:'),
              h('a-select', {
                props: {
                  value: that.addModal.choosing_sts
                },
                style: { width: '100%' },
                on: {
                  change: (val) => {
                    that.addModal.choosing_sts = val;
                  }
                }
              }, [
                h('a-select-option', { props: { value: 'Low' } }, [h('a-tag', {
                  props: { color: 'default' },
                  style: { color: 'rgba(0, 0, 0, 0.65)', border: '1px solid rgb(217, 217, 217)' }, class: 'tag-normals'
                }, 'Low')]),
                h('a-select-option', { props: { value: 'Normal' } }, [h('a-tag', { props: { color: 'green' } }, 'Normal')]),
                h('a-select-option', { props: { value: 'High' } }, [h('a-tag', { props: { color: 'red' } }, 'High')]),
                // h('a-select-option', { props: { value: 'Direct' } }, [ h('a-tag', { props: { color: 'purple' } }, 'Direct Allocated') ]),
              ]
              )
            ]),

            h('div', { style: { marginTop: '10px' } }, [
              h('label', { style: {} }, 'Nilai Rencana Belanja'),
              h('a-input-number', {
                props: {
                  value: that.addModal.nilai,
                  required: true,
                  formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  parser: (value) => value.replace(/(,*)/g, ''),
                  min: 1,
                  max: that.addModal.max_nilai,
                },
                on: {
                  change: (val) => {
                    that.addModal.nilai = val;
                  },
                  keydown: (e) => {
                    that.onlyNumber(e);
                    that.validateMaxValue(e, that.addModal.max_nilai);
                  }
                },
                class: 'width-full m-text-align-right'
              })
            ]),
          ],);
        },
        okText: "Yes",
        cancelText: "No",
        onOk() {

          if (that.addModal.desc == null || that.addModal.desc == '') {
            that.displayMessageValue("error-other", "Keterangan Rencana Belanja is Required!");
            return Promise.reject();
          }

          let tempTotal = _.sumBy(that.datasource.right, function (val) {
            return (val.anggaran_dtl_val_id == item.id ? Number(val.nilai_rencana) : 0)
          });

          if ((tempTotal + that.addModal.nilai) > that.addModal.max_nilai) {
            that.displayMessageValue("error-other", "Rencana Belanja melampaui batas (" +
              that.formatRupiah((tempTotal + that.addModal.nilai))
              + " > " +
              that.formatRupiah(that.addModal.max_nilai)
              + ")!");
            return Promise.reject();
          }

          that.loading.table.left = true
          that.loading.table.right = true
          that.asyncAxiosPost(['expenditurePlanCreate', 'expenditurePlanDraft'].includes(that.$route.name) ? "Rencana_belanja" : "Rencana_belanja/tambah", "json", that.getAuth, {
            periode: that.form.model.period,
            anggaran_dtl_val_id: item.id,
            cost_center: that.form.model.cost_center,
            deskripsi: that.addModal.desc,
            nilai_rencana: that.addModal.nilai,
            rencana_belanja_id: that.id_newtrans,
            status: that.addModal.choosing_sts
          })
            .then((response) => {
              if (that.datasource.right.length == 0 && response.rencana_belanja_id) {
                that.displayMessageValue("success-other", response.message);
                that.disabled.header = true
                that.loading.table.left = false
                that.loading.table.right = false
                that.id_newtrans = response.rencana_belanja_id
                that.datasource.right = response.dtl

                if (that.$route.name.includes('expenditurePlanRevise')) {
                  that.$router.push({
                    name: "expenditurePlanRevise",
                    params: { id: response.rencana_belanja_id }
                  });
                } else {
                  that.$router.push({
                    name: "expenditurePlanDraft",
                    params: { id: response.rencana_belanja_id }
                  });
                }

              } else {
                that.disabled.header = true
                that.id_newtrans = response.rencana_belanja_id
                that.datasource.right = response.dtl

                // that.updateDataTree(that.datasource.left, 'anggaran_dtl_val_id', item.id, 'hidden', true);

                that.loading.table.left = false
                that.loading.table.right = false

                that.displayMessageValue("success-other", response.message);
              }
            })
            .catch((err) => {
              console.log(err);
              that.loading.table.left = false
              that.loading.table.right = false
            });
        },
        onCancel() {
        }
      })
    },
    handleDelete(item) {
      const that = this

      this.$confirm({
        title: "Are you sure to delete?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.table.key_right = item.rencana_belanja_dtl_id

          that.asyncAxiosDelete(
            that.$route.meta.revise ? "Rencana_belanja/hapus" : "Rencana_belanja",
            "application/json",
            that.getAuth,
            { rencana_belanja_dtl_id: item.rencana_belanja_dtl_id }
          )
            .then((response) => {
              that.loading.table.key_right = ''

              that.datasource.right = response.dtl
              // that.updateDataTree(that.datasource.left, 'anggaran_dtl_val_id', item.anggaran_dtl_val_id, 'hidden', false);

              if (response.status && response.status == true) {
                that.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                that.displayMessageValue("error-other", responses);
              }
            })
            .catch(() => {
              that.loading.table.key_right = ''
            });
        },
        onCancel() {
        }
      });
    },
    updateDataTree(data, keyLabel, keyId, newLabel, newValue) {
      _.each(data, (node) => {
        if (node[keyLabel] === keyId) {
          node[newLabel] = newValue;
        }
        if (node.children && !_.isEmpty(node.children)) {
          this.updateDataTree(node.children, keyLabel, keyId, newLabel, newValue);
        }
      });
    },
    getRowClassName(record) {
      return ''
      // return record && record.hidden ? 'hidden-row-budget' : '';
    },
    saveTrans(type) {
      const that = this
      if (type == 'draft') {
        that.displayMessageValue("success-other", 'Save as Draft is successfully!');
        setTimeout(
          function () {
            that.$router.push({
              name: "expenditurePlan",
              params: {},
              query: {
                default_tab_draft: true
              }
            });
          },
          1000
        );
      } else if (type == 'submit') {
        if (that.$route.name.includes('expenditurePlanRevise')) {
          that.asyncAxiosPost("Rencana_belanja/revisi", "json", that.getAuth, {
            rencana_belanja_id: that.id_newtrans
          })
            .then((response) => {
              that.loading.submit = true
              that.displayMessageValue("success-other", "Success Revise manifest");
              setTimeout(
                function () {
                  that.$router.push({
                    name: "expenditurePlanManifest",
                    params: { id: that.id },
                  });
                },
                1000
              );
            })
            .catch((err) => {
              console.log(err);
              that.loading.table.left = false
              that.loading.table.right = false
            });
        } else {
          that.asyncAxiosPost("Rencana_belanja/draft", "json", that.getAuth, {
            rencana_belanja_id: that.id_newtrans
          })
            .then((response) => {
              that.loading.submit = true
              that.displayMessageValue("success-other", response.message);
              setTimeout(
                function () {
                  that.$router.push({
                    name: "expenditurePlan",
                    params: {},
                    query: {
                      default_tab_draft: false
                    }
                  });
                },
                1000
              );
            })
            .catch((err) => {
              console.log(err);
              that.loading.table.left = false
              that.loading.table.right = false
            });
        }
      }
    },
    async getAvailabelPeriode() {
      await this.asyncAxiosGet("rencana_belanja/periode",
        this.getAuth, {
        tlc: this.getAuth.username
      }
      ).then((response) => {
        this.base_data_periode = response.periode
      })
        .catch(() => {

        })
    },
    getPeriodeList() {
      let temp = []
      this.base_data_periode.forEach(element => {
        temp.push({
          key: moment(element.periode).format("YYYY-MM"),
          label: moment(element.periode).locale("id").format('MMMM-YYYY')
        })
      });
      return temp
    },

    async getPreviousBudget(){
      try {
        this.loading.view = true
        const payload = {
          cost_center: this.form.model.cost_center,
          period: this.form.model.period
        }
        console.log(payload);
        
        const response = await this.asyncAxiosGet("rencana_belanja/view_previous_budget", this.getAuth, payload)
        if(response){
          this.show_modal_view = true
          this.loading.view = false
          console.log(response);
          this.modal_title = response.period
          this.list_previous_budget = response.data
        }
        
      } catch (error) { 
        this.loading.view = false
        this.displayMessageValue("error-other", error.response.data.message);
      }
    },

    handleOk(){
      this.show_modal_view = false
    },

    async addPreviousBudget(params){
      try {
        this.temp_id = params.rencana_belanja_dtl_id
        this.loading.add = true
        const payload = {
          periode: this.form.model.period,
          anggaran_dtl_val_id: params.anggaran_dtl_val_id,
          cost_center: params.cost_center,
          deskripsi: params.deskripsi,
          nilai_rencana: params.nilai_rencana,
          rencana_belanja_id: this.id_newtrans,
          status: params.status
        }

        const response = await this.asyncAxiosPost("rencana_belanja", "json", this.getAuth, payload)

        if(response){
          if (this.datasource.right.length == 0 && response.rencana_belanja_id) {
            this.displayMessageValue("success-other", response.message);
            this.disabled.header = true
            this.loading.table.left = false
            this.loading.table.right = false
            this.id_newtrans = response.rencana_belanja_id
            this.datasource.right = response.dtl

            if (this.$route.name.includes('expenditurePlanRevise')) {
              this.$router.push({
                name: "expenditurePlanRevise",
                params: { id: response.rencana_belanja_id }
              });
            } else {
              this.$router.push({
                name: "expenditurePlanDraft",
                params: { id: response.rencana_belanja_id }
              });
            }

          } else {
            this.disabled.header = true
            this.id_newtrans = response.rencana_belanja_id
            this.datasource.right = response.dtl
            this.loading.table.left = false
            this.loading.table.right = false

            this.displayMessageValue("success-other", response.message);
          }
        }
        this.loading.add = false
        this.show_modal_view = false
      } catch (error) {
        console.log(error);
        this.loading.add = false
      }
    }

    // end of methods
  },
  watch: {
    "getCostCenter"() {
      if (this.id && _.isEmpty(this.costCenter)) {
        const filter = this.getCostCenter.filter(
          (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(this.form.model.budget_type.toLowerCase()) >= 0
        );
        this.costCenter = filter;
      }
    }
  }
};
</script>

<style lang="less">
.slider-cep {
  margin: 0px 0px 5px 0px !important;

  .ant-slider-track {
    background-color: #8de3c900 !important;
  }
}

.ant-table-tbody {
  .hidden-row-budget {
    // display: none!important;
  }
}

.slot_sts {
  .ant-tag {
    text-align: center;
  }
}

.tag-defaults {
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid rgb(217, 217, 217);
}

.view-col {
  display: flex;
}

.view-col .ant-form-item {
  width: 100%;
}

.view-col .ant-form-item-control-wrapper,
.view-col .ant-form-item-control {
  width: 100%;
}

.view-col .ant-btn {
  width: 100%;
}
</style>
